const TokenStatuses = [
    { label: 'None', value: '' },
    { label: 'Not Redeemed', value: 'NOT_REDEEMED' },
    { label: 'Redeemed', value: 'REDEEMED' },
    { label: 'Completed', value: 'COMPLETED' },
    { label: 'Disabled', value: 'DISABLED' },
];

export default TokenStatuses;